import { chakra } from '@chakra-ui/react';

const SVGIcon = ({ ...props }) => (
  <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 52" {...props}>
    <g clipPath="url(#a)">
      <rect
        x=".81641"
        y="10.2485"
        width="37"
        height="43"
        rx="4"
        transform="rotate(-15 .8164 10.2485)"
        fill="#DADCE0"
      />
      <g clipPath="url(#b)">
        <rect x="5.75" y="4.72778" width="37" height="43" rx="4" fill="#DADCE0" />
        <rect
          opacity=".15"
          x="8.69336"
          y="51.3943"
          width="34.8844"
          height="34.8844"
          rx="3"
          transform="rotate(-45 8.69336 51.3943)"
          fill="url(#c)"
        />
        <rect
          opacity=".5"
          x="-7.47266"
          y="46.9497"
          width="36.0624"
          height="36.0624"
          rx="4"
          transform="rotate(-45 -7.47266 46.9497)"
          fill="url(#d)"
        />
        <circle opacity=".7" cx="32.25" cy="15.2278" r="4.5" fill="url(#e)" />
      </g>
      <rect x="6.75" y="5.72778" width="35" height="41" rx="3" stroke="#fff" strokeWidth="2" />
    </g>
    <defs>
      <linearGradient
        id="c"
        x1="21.216"
        y1="45.7256"
        x2="55.2565"
        y2="53.966"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#131313" />
        <stop offset="1" stopColor="#4B4B4B" />
      </linearGradient>
      <linearGradient
        id="d"
        x1="15.1548"
        y1="42.3148"
        x2="23.2865"
        y2="73.074"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#131313" />
        <stop offset="1" stopColor="#4B4B4B" />
      </linearGradient>
      <linearGradient
        id="e"
        x1="30.9808"
        y1="9.26528"
        x2="37.1553"
        y2="11.6501"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#131313" />
        <stop offset="1" stopColor="#4B4B4B" />
      </linearGradient>
      <clipPath id="a">
        <path fill="#fff" transform="translate(.75 .67212)" d="M0 0h47v51.1111H0z" />
      </clipPath>
      <clipPath id="b">
        <rect x="5.75" y="4.72778" width="37" height="43" rx="4" fill="#fff" />
      </clipPath>
    </defs>
  </svg>
);

const ImageUploadMultiple = chakra(SVGIcon);
export default ImageUploadMultiple;
